"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.string.includes.js");

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _md = require("react-icons/md");

var _wrapperSidebarContext = require("../wrapperSidebarContext");

var S = _interopRequireWildcard(require("./FlatOption.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FlatOption = _ref => {
  var {
    accordionInfo
  } = _ref;
  var [isActive, setIsActive] = (0, _react.useState)(false);
  var {
    redirectTo,
    currentPathname,
    setCurrentPathname,
    toggleSidebar
  } = (0, _react.useContext)(_wrapperSidebarContext.WrapperSidebarContext);

  var goToSelectedPath = () => {
    var nextRoute = accordionInfo.path;
    setCurrentPathname(nextRoute);
    redirectTo(nextRoute);
    toggleSidebar();
  };

  (0, _react.useEffect)(() => {
    setIsActive(false);
    currentPathname.includes(accordionInfo.path) && setIsActive(true);
  }, [currentPathname]);
  return /*#__PURE__*/_react.default.createElement(S.FlatOption, {
    onClick: () => goToSelectedPath(),
    className: (0, _classnames.default)({
      active: isActive
    })
  }, /*#__PURE__*/_react.default.createElement(S.Content, null, accordionInfo.icon, accordionInfo.name), /*#__PURE__*/_react.default.createElement(_md.MdNavigateNext, {
    size: "1.3rem"
  }));
};

var _default = FlatOption;
exports.default = _default;